"use strict";
//This file defines the default system roles
var USER_GROUP_ROLES = {
    ENTITY: {
        ADMINISTRATOR: {
            role_id: 'client_admin',
            role_name: 'client admin'
        },
        USER: {
            role_id: 'client_user',
            role_name: 'client user'
        },
        COMPLIANCE: {
            role_id: 'client_compliance',
            role_name: 'client_compliance'
        },
        SERVICE_PROVIDER_USER: {
            role_id: 'entity_sp_user',
            role_name: 'entity service provider user'
        },
        SERVICE_PROVIDER_ACCOUNTING: {
            role_id: 'entity_sp_accounting',
            role_name: 'entity service provider accounting'
        },
        SERVICE_PROVIDER_CORPSEC: {
            role_id: 'entity_sp_corpsec',
            role_name: 'entity service provider corporate secretary'
        },
        SERVICE_PROVIDER_ADMIN: {
            role_id: 'entity_sp_admin',
            role_name: 'entity service provider admin',
        }
    },
    SERVICE_PROVIDER: {
        ADMINISTRATOR: {
            role_id: 'staff_admin',
            role_name: 'staff admin'
        },
        USER: {
            role_id: 'staff_user',
            role_name: 'staff user'
        },
        BOOKKEEPING_ADMINISTRATOR: {
            role_id: 'staff_bookkeeper_admin',
            role_name: 'staff bookkeeper admin'
        },
        BOOKKEEPING_USER: {
            role_id: 'staff_bookkeeper_user',
            role_name: 'staff bookkeeper user'
        }
    },
    ZAVE: {
        SYSTEM_ADMIN: {
            role_id: 'zave_system_admin',
            role_name: 'zave system admin'
        },
        SYSTEM_ENGINEER: {
            role_id: 'zave_system_engineer',
            role_name: 'zave system engineer'
        },
        SYSTEM_HELPDESK: {
            role_id: 'zave_system_helpdesk',
            role_name: 'zave system helpdesk'
        },
    }
};
module.exports = USER_GROUP_ROLES;
